export default class IpApi {
  async addressByIp (ip) {
    const result = await window.jQuery.get(`http://maps.dev.paggcerto.com.br/${ip}`)
    return result
  }
}
